import { ROLE_TRANSLATION_ALIASES } from '../../../constants/user'

/**
 * @param {string} name
 * @param {string | null | undefined} group
 * @param {(key: string) => string} t
 */
export function getProviderSearchItemTitle({ group, name, t }) {
  const normalizedGroup = group?.toLowerCase()
  const groupTranslationKey = normalizedGroup
    ? ROLE_TRANSLATION_ALIASES[normalizedGroup]
    : null

  const role = groupTranslationKey ? t(groupTranslationKey) : group

  return role ? `${name} | ${role}` : name
}
